import { render, staticRenderFns } from "./article13.vue?vue&type=template&id=242a1d18&scoped=true"
import script from "./article13.vue?vue&type=script&lang=js"
export * from "./article13.vue?vue&type=script&lang=js"
import style0 from "./article13.vue?vue&type=style&index=0&id=242a1d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a1d18",
  null
  
)

export default component.exports